import { Heading } from "native-base";

export default Heading;